import { css } from '@/styled-system/css';

const shimmerBlock = {
  animation: 'shimmering',
  bgGradient: 'heroPhotoContainerBgGradient',
  backgroundSize: '200% 100%',
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
} as const;

export const skeletonContainer = css({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'hpxWhite',
  position: 'relative',
  minHeight: '100vh',
  '@supports (min-height: 100dvh)': {
    minHeight: '100dvh',
  },
  md: {
    minHeight: 'unset',
    height: '100%',
    overflow: 'hidden',
  },
});

export const skeletonMain = css({
  flex: 1,
  position: 'relative',
  md: {
    overflow: 'auto',
  },
});

export const skeletonGalleryPadding = css({
  md: {
    px: '4x',
  },
});

export const skeletonGalleryContainer = css({
  position: 'relative',
  width: '100%',
});

// Mobile: full-width 4:3 carousel placeholder
export const skeletonMobileCarousel = css({
  display: 'block',
  width: '100%',
  aspectRatio: '4/3',
  ...shimmerBlock,
  md: {
    display: 'none',
  },
});

// Desktop: bento grid skeleton matching the 4-photo layout
export const skeletonBentoGrid = css({
  display: 'none',
  md: {
    display: 'grid',
    gap: '1x',
    height: '510px',
    borderRadius: '12px',
    overflow: 'hidden',
    gridTemplateColumns: 'repeat(10, 1fr)',
    gridTemplateRows: '1fr 1fr',
    '& > *:nth-child(1)': { gridColumn: 'span 6' },
    '& > *:nth-child(2)': { gridColumn: 'span 4' },
    '& > *:nth-child(3)': { gridColumn: 'span 4' },
    '& > *:nth-child(4)': { gridColumn: 'span 6' },
  },
});

export const skeletonBentoCell = css(shimmerBlock);

// Matches DesktopStickyHeader: desktopHeader wraps desktopHeaderColumns (grid 1fr auto 1fr)
export const skeletonDesktopHeader = css({
  display: 'none',
  md: {
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
    width: '100%',
    minHeight: '56px',
    px: '4x',
    py: '2x',
    gap: '2x',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'hpxGrey400',
  },
});

export const skeletonHeaderBarLeft = css({
  justifySelf: 'start',
  height: '20px',
  width: '130px',
  borderRadius: '4px',
  backgroundColor: 'hpxGrey100',
});

export const skeletonHeaderBarCenter = css({
  justifySelf: 'center',
  height: '20px',
  width: '160px',
  borderRadius: '4px',
  backgroundColor: 'hpxGrey100',
});

export const skeletonHeaderBarRight = css({
  justifySelf: 'end',
  height: '32px',
  width: '80px',
  borderRadius: '16px',
  backgroundColor: 'hpxGrey100',
});

export const skeletonContentPadding = css({
  paddingLeft: '2x',
  paddingRight: '2x',
  paddingTop: '2x',
  md: {
    paddingLeft: '4x',
    paddingRight: '4x',
  },
});

export const skeletonBar = css({
  height: '14px',
  borderRadius: '4px',
  backgroundColor: 'hpxGrey100',
  marginBottom: '1x',
});
